// Session manager to coordinate session expiration between axios interceptor and React components
class SessionManager {
  constructor() {
    this.listeners = [];
    this.isExpired = false;
  }

  // Subscribe to session expiration events
  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((listener) => listener !== callback);
    };
  }

  // Notify all listeners that session has expired
  notifySessionExpired() {
    if (!this.isExpired) {
      this.isExpired = true;
      this.listeners.forEach((callback) => callback());
    }
  }

  // Reset session expiration state
  reset() {
    this.isExpired = false;
  }

  // Get current expiration state
  getIsExpired() {
    return this.isExpired;
  }
}

export const sessionManager = new SessionManager();

